const usageItems = [
  {
    label: '導入方法',
    description:
      'システムはクラウド（SaaS）形式でご提供。発行された埋め込みコード（scriptタグ等）を、自社ホームページやポータルサイトのHTMLに貼り付けるだけで、その日から稼働を開始できます。',
  },
  {
    label: '法人向けカスタマイズ\n開発のご相談',
    description:
      '社内フォルダ（SharePointやGoogleドライブ等）との直接連携、画面UIの完全オリジナルブランド化、特定の業務システム（CRM等）とのAPI連携など、一歩進んだ社内DXに合わせた個別ビルド・カスタマイズ開発も承ります。',
  },
];

const MskKnowledgeAiUsage = () => {
  return (
    <section id="usage" className="py-20 bg-[#F0F7EC]">
      <div className="max-w-5xl mx-auto px-6 space-y-10">
        <div className="text-center mb-4">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Usage
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            ご利用・ご相談にあたって
          </h4>
        </div>

        <div className="bg-white rounded-2xl p-5 md:p-10 shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
          <div className="space-y-6">
            {usageItems.map((item) => (
              <div key={item.label} className="flex flex-col sm:flex-row sm:gap-4">
                <div className="sm:w-48 shrink-0 mb-1 sm:mb-0">
                  <span className="text-[13px] font-semibold text-[#89B56B] whitespace-pre-line">
                    {item.label}
                  </span>
                </div>
                <div className="flex-1">
                  <p className="text-[13px] text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MskKnowledgeAiUsage;
